/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdImageViewerProps } from './type';

export const imageViewerDefaultProps: TdImageViewerProps = {
  closeBtn: true,
  deleteBtn: false,
  images: [],
  defaultIndex: 0,
  maxZoom: 3,
  showIndex: false,
  defaultVisible: false,
};
